import React from "react";

type PropTypes = {
    src: string;
    alt?: string;
    width?: number;
    height?: number;
    className?: string;
};

const LocalImage = ({ src, alt, width, height, className }: PropTypes) => {
    if (!src) {
        return null;
    }

    return <img src="/${src}" alt={alt} width={width} height={height} className={className} />;
};

export default LocalImage;
